import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthState } from 'src/app/states/auth.state';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Utility, setTimeout$ } from 'src/app/core/common';
import { FavoriteService } from 'src/app/services/favorite.service';
import { JobService } from 'src/app/services/job.service';
import { SharedService } from 'src/app/services/shared.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { environment } from 'src/environments/environment';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { JobCriteria, JobSortType, ModelType } from 'src/app/common';

@Component({
  selector: 'job-list',
  templateUrl: './job-list-new.component.html',
  styleUrls: ['./job-list-new.component.scss']
})
export class JobListNewComponent implements OnInit, AfterViewInit, OnDestroy {
  onChangesFired: boolean;
  user: any;
  constructor(private route: ActivatedRoute, private router: Router, private _sanitizer: DomSanitizer,
    private jobService: JobService, public sharedService: SharedService, private spinner: SpinnerService,
    private analyticsService: AnalyticsService, private store: Store, private favoriteService: FavoriteService) {
    if (sharedService.isBrowser)
      AuthState.user$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(user => this.user = user);
  }
  get page() { return Math.floor(this.from / this.limit) + 1; }
  get totalPage() { return Math.floor(this.total / this.limit) + 1; }
  Utility = Utility;

  @Input('detail-id') detailId: string;
  @Input() criteria: JobCriteria = new JobCriteria();
  @Input() limit = 50;
  @Input() newDate?: Date;
  @Input() jobs: any[];
  @Input() loadMoreEnabled = false;
  @Input() from = 0;
  @Input() showResultsHeader = true;
  @Input() allowSearchFallback = false;
  @Input() sort: JobSortType = JobSortType.Score;

  // @Output() criteriaChange = new EventEmitter<any>();
  // @Output() change = new EventEmitter<string>();
  // onChange() { this.change.emit(this.criteria); }
  @Output() detail = new EventEmitter<string>();
  title: string;
  searchTitle: string;
  nearbyJobs: any[];
  contents: any[];
  seoContent: any;
  total: number;
  moreFrom = 0;
  loadingMore: boolean;
  pages: number[];

  imageUrl = environment.app.filesUrl;
  @ViewChild('listContainer') listContainer: ElementRef;
  detailStyle: any;
  listContainerTop: number;

  favoriteIds: string[] = [];

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.criteria) {
      this.criteria = changes.criteria.currentValue;
      this.onChangesFired = true;
      await this.load();
    }
  }

  ngAfterViewInit(): void {
    if (!Utility.mobile) {
      setTimeout$(() => {
        this.detailStyle = this.getDetailStyle();
      }, 500);
    }
  }

  getDetailStyle() {
    const height = Math.max(window.innerHeight, 670) - Utility.headerHeight - 20;

    return this._sanitizer.bypassSecurityTrustStyle(
      `max-height: ${height}px;`
    );
  }


  open(jobId?: string, loc?: number) {
    if (!jobId) {
      this.detailId = undefined;
      return;
    }
    this.detail.emit(jobId);
    if (jobId == 'content') {
      this.detailId = 'content';
      this.sharedService.scrollToTop();
      return;
    }

    this.detailId = jobId;
    if (this.sharedService.isBrowser) {
      if (Utility.mobile) {
        this.router.navigate(['job', jobId]);
      } else {
        var params = Object.assign({}, this.route.snapshot.queryParams);
        params.id = jobId;
        this.router.navigate([], { relativeTo: this.route, queryParams: params });
      }
    }
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.sharedService.removeLink('rel=\'prev\'');
    this.sharedService.removeLink('rel=\'next\'');
    this.sharedService.removeLink('rel=\'canonical\'');
    window.onpopstate = null;

    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  async ngOnInit() {
    window.onpopstate = () => delete this.detailId;
    if (!this.onChangesFired && this.jobs == undefined)
      await this.load();
  }

  private async load() {
    this.spinner.show('list');
    // this.sharedService.scrollToTop();
    await this.search();
    delete this.nearbyJobs;
    // if (this.total < this.limit && this.criteria.State)
    //   this.nearbyJobs = (await this.jobService.nearby(this.params.l, this.params.q, (!this.params.q ? 100 : 200), true, 0, 30)).jobs;
    this.spinner.hide('list');
    this.moreFrom = this.from + this.limit;
    this.contents = []; // await this.contentService.keyword(this.params.q, this.params.l, 0, 5);
    this.seoContent = undefined;
    if (this.contents.length) {
      this.seoContent = this.contents[0];
    }
  }

  private async search(more = false) {
    if (!this.criteria) return;
    this.criteria.AllowSearchFallback = this.allowSearchFallback;
    this.criteria.Sort = this.sort;
    const result = await this.jobService.search(this.criteria, !more ? this.from : this.moreFrom, this.limit);
    if (more && this.jobs) { this.jobs.push(...result.jobs); } else { this.jobs = result.jobs; }

    const favIds = result.jobs.map(_ => _.Id);
    if (!more && this.detailId) { favIds.push(this.detailId); }
    const favs = await this.favoriteService.search({ ItemIds: favIds }, 0, favIds.length);
    if (favs) {
      this.favoriteIds.push(...favs.favorites.map(_ => _.ItemId));
      this.favoriteIds = Utility.distinct(this.favoriteIds);
    }

    this.total = result.total;
  }

  async loadMore() {
    if (!this.loadMoreEnabled || !this.jobs || this.loadingMore) { return; }
    this.loadingMore = true;
    this.spinner.show('more');
    try {
      if (this.moreFrom >= this.total) { return; }
      await this.search(true);

      this.moreFrom += this.limit;
    } finally {
      delete this.loadingMore;
      this.spinner.hide('more');
    }
  }
  async setFavorite(job: any | string, e?: boolean) {
    var index = this.favoriteIds.indexOf(job.Id);
    if (index < 0)
      this.favoriteIds.push(typeof (job) == 'string' ? job : job.Id);
    else
      this.favoriteIds.splice(index, 1);

    if (e == undefined) {
      e = await this.favoriteService.toggle({
        ItemId: job.Id,
        Type: ModelType.Job,
        ExpirationTime: job.ExpirationTime,
        Item: {
          title: job.Title,
          company: job.Company,
          state: job.State,
          city: job.City
        }
      });
    }

    if (typeof (e) == 'boolean') {
      index = this.favoriteIds.indexOf(job.Id);
      if (e && index < 0) {
        this.favoriteIds.push(typeof (job) == 'string' ? job : job.Id);
      } else if (!e && index >= 0) {
        this.favoriteIds.splice(index, 1);
      }
    }
  }
}
